<template>
  <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">批次线查询</span>
          </div>
        </div>

        <div id="select-banner" style="margin-right: 120px;">
          <el-form
            :model="form"
            inline
            style="display: flex; align-items: center"
            label-width="80px">
            <el-form-item label="所属省份" style="display: flex;">
                  <el-select @change="chaPice()" v-model="form.province" placeholder="全部" size="small"  style="width:120px;">
                    <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="组别" style="display: flex;">
                  <el-select @change="chaPice()" v-model="form.group_d" placeholder="全部" size="small"  style="width:120px;">
                    <el-option v-for="item in omit_group_id" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
            <el-form-item style="display: flex">
              <el-button type="success" size="small" @click="chaPice()">
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>


      <div style="width:80%;height: 78%;overflow-y: auto;margin: 0 auto;" v-loading="loading" v-if="list.length>0">
         <div v-for="(item,i) in list" :key="i">
             <h4>{{item.year}}年</h4>
             <el-table :data="[1]" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}">
              <el-table-column label="强基线" align="center">
                {{
                  list.find(r=>r.year==item.year).strong_basi
                }}
              </el-table-column>
              <el-table-column label="本科线" align="center">
                {{
                  list.find(r=>r.year==item.year).undergraduate_line
                }}
              </el-table-column>
              <el-table-column label="专科线" align="center">
                {{
                  list.find(r=>r.year==item.year).specialist_line
                }}
              </el-table-column>
        </el-table>
         </div>
      </div>
      <div v-if="list.length==0">
        <el-empty></el-empty>
      </div>


    </div>
  </div>
</template>
<script>
import { chaPice,groupFind } from "@/api/gw/zonghe.js"
import cityJson from "@/utils/city.json";
export default{
  data(){
    return{
      cityData: cityJson,
      loading:false,
      form:{
					province:"河北",
					group_d:""//物理科目组合
				},
				list:[],
        omit_group_id:[],
    }
  },
  mounted(){
    this.groupFind();
    this.chaPice();
  },
  methods:{
    chaPice(){
        const examTypeRaw = localStorage.getItem('selectedExamType');
        const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
        let form = { ...this.form, examType };
				this.loading = true
        chaPice(form).then(res=>{
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
    },
    groupFind(){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      groupFind({ examType }).then((res)=>{
        console.log("字典表",res.data);
        this.omit_group_id = res.data.omit_group_id
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/comprehensive/components/pici.vue